// extracted by mini-css-extract-plugin
module.exports = {"CheckboxStyle":"checkbox_CheckboxStyle__1qX4L","CheckboxLabel":"checkbox_CheckboxLabel__26CFj","CheckboxInput":"checkbox_CheckboxInput__Xpye3"};